// This makes our testimonial quotes slide like a slideshow!
document.addEventListener('DOMContentLoaded', function() {
  // Wait until the page is fully loaded
  
  // Check if we have the Swiper tool available
  if (typeof Swiper !== 'undefined') {
    // Create our slider
    new Swiper('.js-testimonials-slider', {
      // Show 1 slide on phone screens
      slidesPerView: 1,
      // Space between slides
      spaceBetween: 30,
      // Make it go round and round
      loop: true,
      // Auto-play (like a slideshow)
      autoplay: {
        delay: 5000, // Wait 5 seconds before sliding
      },
      // The little dots at the bottom
      pagination: {
        el: '.swiper-pagination',
        clickable: true, // Let people click the dots
      },
      // The arrow buttons
      navigation: {
        nextEl: '.swiper-button-next', // Next button
        prevEl: '.swiper-button-prev', // Previous button
      },
      // Show more slides on bigger screens
      breakpoints: {
        768: {
          slidesPerView: 2, // Show 2 on tablets
        },
        1024: {
          slidesPerView: 3, // Show 3 on computers
        }
      }
    });
  }
});